var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "step_component_wrapper"
    }
  }, [_c('div', {
    staticClass: "slot-content"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon",
    class: {
      'error_highlight': _vm.machineValid != 0
    }
  }, [_c('i', {
    class: _vm.$root.icons.search_btn,
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.machineInput),
      expression: "machineInput"
    }],
    staticClass: "form-control",
    class: {
      'error_highlight': _vm.machineValid != 0
    },
    attrs: {
      "id": "machine_selector",
      "type": "text",
      "placeholder": _vm.machineLabels[_vm.machineValid]
    },
    domProps: {
      "value": (_vm.machineInput)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.machineInput = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.renderModelInput) ? _c('div', {
    staticClass: "input-group",
    staticStyle: {
      "margin-top": "25px"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    class: {
      'error_highlight': _vm.modelValid != 0
    }
  }, [_c('i', {
    class: _vm.$root.icons.search_btn,
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.modelInput),
      expression: "modelInput"
    }],
    staticClass: "form-control",
    class: {
      'error_highlight': _vm.modelValid != 0
    },
    attrs: {
      "id": "model_selector",
      "name": "model",
      "type": "text",
      "placeholder": _vm.modelLabels[_vm.modelValid]
    },
    domProps: {
      "value": (_vm.modelInput)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.modelInput = $event.target.value
      }
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "slot-button"
  }, [(!_vm.backTo1Allowed) ? _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        _vm.$root.logout()
      }
    }
  }, [_vm._v("Logout")]) : _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        _vm.$emit('backward')
      }
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate('back', null)))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "width": "auto"
    },
    on: {
      "click": _vm.skip
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate('skip', null)))]), _vm._v(" "), (_vm.formFilled) ? _c('button', {
    staticClass: "btn btn-primary-default",
    on: {
      "click": _vm.check
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate('confirm', null)))]) : _c('popover-alert', {
    attrs: {
      "effect": "fade",
      "placement": "top",
      "title": !_vm.machineFilled ? _vm.machineLabels[3] : _vm.modelLabels[3],
      "content": _vm.$Jed.firstUpperTranslate('you are being redirected to the %1$s menu', null, {
        string: this.$Jed.translate('selezione %1$s', null, {
          key: 'index'
        })
      }),
      "ok": _vm.skip,
      "popoverStyle": {
        right: '10px',
        'max-width': '200px',
        width: '100%',
        'font-size': 'small',
        height: 'max-content',
        bottom: '60px'
      },
      "arrowStyle": {
        left: '75%'
      },
      "textStyle": {
        color: '#222'
      },
      "classes": "autoleft autotop"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary-default",
    staticStyle: {
      "margin": "0px 5px"
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate('confirm', null)))])])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02e2fdc2","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/loader/steps/IdentificazioneProdotto.vue
// module id = 1480
// module chunks = 1